import axios from "axios";

var baseURL = process.env.REACT_APP_API_BASE_URL;
var apis = {

    'saveITMasters': `${baseURL}it-depreciation/saveitmaster`,
    'getITMasterList': `${baseURL}it-depreciation/getitmasterlist`,
    'deleteITMaster': `${baseURL}it-depreciation/deleteitmaster`,
    'getITMasterInfo': `${baseURL}it-depreciation/getitmasterinfo`,
    'saveITMasterList': `${baseURL}it-depreciation/saveitmasterlist`,
    'getITMasterMappingList': `${baseURL}it-depreciation/getitmastermappinglist`,
    'deleteITMappingMaster': `${baseURL}it-depreciation/deleteitmappingmaster`,
    'getITMasterMappingInfo': `${baseURL}it-depreciation/getitmastermappinginfo`,
    'getBlockList': `${baseURL}it-depreciation/getblocklist`,
    'saveITDepBlockWise': `${baseURL}it-depreciation/saveitdepblockwise`,
    'getSavedITDepBlockWise': `${baseURL}it-depreciation/getsaveditdepblockwise`,
    'createYearDepreciation': `${baseURL}it-depreciation/createyeardepreciation`,
    'lockFinYearDepreciation': `${baseURL}it-depreciation/lockfinyeardepreciation`,
    'getCreateYearData': `${baseURL}it-depreciation/getcreateyeardata`,
    'getFinancialYearList': `${baseURL}it-depreciation/getfinancialyearlist`,
    'uploadITDepreciationexcel': `${baseURL}it-depreciation/uploaditdepreciationexcel`,
}
export function saveITMasters(data) {
    return axios.put(apis.saveITMasters, data);
}export function getITMasterList(data) {
    return axios.put(apis.getITMasterList, data);
}export function deleteITMaster(data) {
    return axios.put(apis.deleteITMaster, data);
}export function getITMasterInfo(data) {
    return axios.put(apis.getITMasterInfo, data);
}export function saveITMasterList(data) {
    return axios.put(apis.saveITMasterList, data);
}export function getITMasterMappingList(data) {
    return axios.put(apis.getITMasterMappingList, data);
}export function deleteITMappingMaster(data) {
    return axios.put(apis.deleteITMappingMaster, data);
}export function getITMasterMappingInfo(data) {
    return axios.put(apis.getITMasterMappingInfo, data);
}export function getBlockList(data) {
    return axios.put(apis.getBlockList, data);
}export function saveITDepBlockWise(data) {
    return axios.put(apis.saveITDepBlockWise, data);
}export function getSavedITDepBlockWise(data) {
    return axios.put(apis.getSavedITDepBlockWise, data);
}export function createYearDepreciation(data) {
    return axios.put(apis.createYearDepreciation, data);
}export function lockFinYearDepreciation(data) {
    return axios.put(apis.lockFinYearDepreciation, data);
}export function getCreateYearData(data) {
    return axios.put(apis.getCreateYearData, data);
}export function getFinancialYearList(data) {
    return axios.put(apis.getFinancialYearList, data);
}export function uploadITDepreciationexcel(data) {
    return axios.put(apis.uploadITDepreciationexcel, data);
}